import Vue from 'vue';
import App from './App';

Vue.config.productionTip = false
import baseStore from "@shared/stores/baseStore";
import appStore from "./appStore";

/* eslint-disable no-new */
new Vue({

    el: '#app', components: {App}, template: '<App/>',

    baseStore: baseStore,

    appStore: appStore,

    beforeCreate() {
        baseStore.commit('initialiseStore');
        appStore.commit('initialiseStore');
    }
});
